<div class="form-check custom-checkbox">
	<input class="form-check-input"
		[ngClass]="nrClass"
		type="checkbox"
		id="{{id + '_icb'}}"
		[ngModel]="multiSelect.allSelected | async"
		(ngModelChange)="changeSelection($event)" />
	<label class="form-check-label"
		[ngClass]="nrLabelClass"
		*ngIf="nrLabel"
		for="{{id + '_icb'}}">{{nrLabel}}</label>
</div>
